import { Avatar, Dropdown, Typography, theme as antdTheme } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import { useAuthStore } from '@/store/auth';
import { logout } from '@/api/auth';

export function UserMenu() {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();
  const { token } = antdTheme.useToken();

  const items = [
    {
      key: 'preferences',
      icon: <SettingOutlined />,
      label: 'Preferences',
      onClick: () => navigate('/me/preferences'),
    },
    { type: 'divider' as const },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Sign out',
      danger: true,
      onClick: async () => {
        await logout();
        clear();
        navigate('/login', { replace: true });
      },
    },
  ];

  const initials = (user?.fullName ?? user?.username ?? 'U').split(/[ _.@-]+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase();

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <span
        role="button"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
          padding: '4px 10px 4px 4px',
          borderRadius: 999,
          cursor: 'pointer',
          border: `1px solid ${token.colorBorderSecondary}`,
        }}
      >
        <Avatar size={28} style={{ background: token.colorPrimary }} icon={!user && <UserOutlined />}>
          {user ? initials : null}
        </Avatar>
        <span style={{ lineHeight: 1.15, paddingRight: 4 }}>
          <Typography.Text strong style={{ display: 'block', fontSize: 13 }}>
            {user?.fullName ?? user?.username ?? 'Guest'}
          </Typography.Text>
          <span style={{ fontSize: 11, color: token.colorTextTertiary }}>
            {user?.role ?? 'unauthenticated'}
          </span>
        </span>
      </span>
    </Dropdown>
  );
}
